<template>
  <footer class="footer-container">
    <div class="stars-container">
      <div 
        v-for="n in 50" 
        :key="'star-'+n" 
        class="star" 
        :style="generateStarStyle()"
      ></div>
    </div>

    <div class="shooting-stars">
      <div 
        v-for="n in 4" 
        :key="'shooting-'+n" 
        class="shooting-star"
      ></div>
    </div>

    <div class="footer-content">
      <img src="@/assets/logo4.png" alt="Logo" class="footer-logo" />
      <div class="footer-text">
        <div class="footer-title">MY EVENTO DIGITAL</div>
        <div class="footer-subtext">Invitaciones Digitales</div>
        <div class="footer-subtext">Gestión de lista de invitados</div>
      </div>
    </div>

    <div class="footer-bottom">
      <p class="footer-link">
        ¿Te interesa nuestro servicio? <br />
        <a
          href="https://wa.me/16128072269?text=Me%20gustar%C3%ADa%20informaci%C3%B3n%20de%20invitaciones%20digitales"
          target="_blank"
          class="demo-link"
        >
          Pide un demo
        </a>
      </p>
      <p class="copyright">
        © 2024 por My Evento Digital
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
  setup() {
    const generateStarStyle = () => {
      return {
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`,
        width: `${Math.random() * 2 + 1}px`,
        height: `${Math.random() * 2 + 1}px`,
        animationDuration: `${Math.random() * 3 + 2}s`,
        animationDelay: `${Math.random() * 5}s`,
      };
    };

    return { generateStarStyle };
  }
};
</script>

<style scoped>
.footer-container {
  position: relative;
  /* Fondo mejorado: Degradado oscuro a transparente sobre la imagen para que brillen las estrellas */
  background-image: 
    linear-gradient(to bottom, 
      rgba(0, 0, 0, 0.267) 60%, 
      rgba(0, 0, 0, 0.7) 85%, 
      rgba(0, 0, 0, 0.95) 100%
    ),
    url('@/assets/Diseño sin título (7) - copia.jpg');
  background-size: cover;
  background-position: center center; 
  background-size: cover;
  background-position: center;
  color: #ffffff;
  padding: 80px 20px 40px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow: hidden;
}

/* --- SISTEMA DE ESTRELLAS --- */
.stars-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.star {
  position: absolute;
  background: white;
  border-radius: 50%;
  box-shadow: 0 0 5px white;
  animation: twinkle linear infinite;
}

@keyframes twinkle {
  0%, 100% { opacity: 0.3; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.2); }
}

/* --- ESTRELLAS FUGACES --- */
.shooting-stars {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}

.shooting-star {
  position: absolute;
  top: 0;
  left: 50%;
  width: 2px;
  height: 2px;
  background: white;
  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.1),
              0 0 0 8px rgba(255, 255, 255, 0.1),
              0 0 20px rgba(255, 255, 255, 1);
  border-radius: 50%;
  opacity: 0;
  animation: shoot linear infinite;
}

.shooting-star::before {
  content: '';
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100px;
  height: 1px;
  background: linear-gradient(90deg, white, transparent);
}

.shooting-star:nth-child(1) { top: 0; left: 80%; animation-duration: 3s; animation-delay: 0s; }
.shooting-star:nth-child(2) { top: 20%; left: 90%; animation-duration: 4s; animation-delay: 2s; }
.shooting-star:nth-child(3) { top: 0; left: 40%; animation-duration: 5s; animation-delay: 4s; }
.shooting-star:nth-child(4) { top: 50%; left: 100%; animation-duration: 3s; animation-delay: 7s; }

@keyframes shoot {
  0% { transform: rotate(-45deg) translateX(0); opacity: 1; }
  70% { opacity: 1; }
  100% { transform: rotate(-45deg) translateX(-1000px); opacity: 0; }
}

/* --- CONTENIDO --- */
.footer-content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.footer-logo {
  width: 70px;
  height: auto;
  margin-bottom: 15px;
  filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.3));
}

.footer-title {
  font-size: 16px;
  letter-spacing: 3px;
  color: #fff;
  margin-bottom: 5px;
  font-weight: bold;
}

.footer-subtext {
  font-family: 'padres', sans-serif;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.5;
}

.footer-bottom {
  position: relative;
  z-index: 2;
  margin-top: 30px;
  text-align: center;
}

.demo-link {
  color: #000;
  font-weight: 600;
  background-color: #ffffff;
  padding: 10px 24px;
  border-radius: 50px; /* Más redondeado para un look moderno */
  text-decoration: none;
  margin-top: 15px;
  display: inline-block;
  transition: all 0.3s ease;
  font-family: 'padres', sans-serif;
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
}

.demo-link:hover {
  background-color: #000;
  color: #fff;
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(255,255,255,0.2);
}

.copyright {
  margin-top: 25px;
  font-size: 11px;
  opacity: 0.6;
  font-family: 'padres', sans-serif;
}

@media (max-width: 576px) {
  .footer-container {
    padding: 60px 15px 30px;
    clip-path: ellipse(150% 100% at 50% 100%);
  }
}
</style>